import React from 'react';
import { array, func, number, bool, object, string } from 'prop-types';
import { themr } from 'react-css-themr';

import Latex from '@blueberry/components/Latex';

import styles from './AnswerBlock.scss';
const cx = require('classnames/bind').bind(styles);

function AnswerBlock({
  ansText,
  answerIndex,
  clickAnswer,
  hasLatex,
  ansImages,
  correctAns,
  showAnswer,
  theme,
  yourAnswerHint,
  correctAnswerHint,
}) {
  const answers = [];
  for (let i = 0; i < 4; i++) {
    const image = ansImages[i];
    const text = ansText[i];

    const isSelectedIndex = answerIndex === i;
    const isCorrect = showAnswer && i === correctAns;
    const isIncorrect = showAnswer && isSelectedIndex && i !== correctAns;

    const ans = (
      <div
        key={i}
        className={cx(theme.answer, {
          [theme.active]: isSelectedIndex,
          [theme.correct]: isCorrect,
          [theme.incorrect]: isIncorrect,
        })}
        onClick={clickAnswer(i)}
      >
        <h6 className={theme.number}>{String.fromCharCode(i + 65)}</h6>
        <div className={theme.textBlock}>
          {isIncorrect && !!yourAnswerHint && (
            <span className={theme.resultHint}>{yourAnswerHint}</span>
          )}
          {isCorrect && !!correctAnswerHint && (
            <span className={theme.resultHint}>{correctAnswerHint}</span>
          )}
          {!!text && (
            <span className={theme.text}>
              {hasLatex ? <Latex content={text} /> : text}
            </span>
          )}
          {!!image && <img src={image} />}
        </div>
      </div>
    );
    answers.push(ans);
  }

  return <div className={theme.root}>{answers.map(p => p)}</div>;
}

AnswerBlock.propTypes = {
  answerIndex: number.isRequired,
  clickAnswer: func.isRequired,
  hasLatex: bool.isRequired,
  theme: object.isRequired,
  ansImages: array,
  ansText: array,
  correctAns: number,
  correctAnswerHint: string,
  showAnswer: bool,
  yourAnswerHint: string,
};

AnswerBlock.defaultProps = {
  ansImages: [],
  ansText: [],
  correctAns: -1,
  showAnswer: false,
  yourAnswerHint: undefined,
  correctAnswerHint: undefined,
};

export default themr('DefaultAnswerBlockTheme', styles)(AnswerBlock);



// WEBPACK FOOTER //
// ./app/components/AnswerBlock/AnswerBlock.jsx